var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 693,
    viewBox: "0 0 1920 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_404_15736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -91,
    y: 0,
    width: 2102,
    height: 693
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2011 0H-91V693H2011V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_404_15736)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M806.5 708.656C442.5 436.656 370.5 -31.3446 -91 1.6561",
    stroke: "url(#paint0_radial_404_15736)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75 706.655C35.333 694.655 -53.3 672.255 -90.5 678.655",
    stroke: "url(#paint1_radial_404_15736)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M782.903 708.573C429.365 444.96 356.829 -8.66622 -90.9844 23.4764",
    stroke: "url(#paint2_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M759.305 708.49C416.23 453.264 343.157 14.0118 -90.9688 45.2964",
    stroke: "url(#paint3_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M735.708 708.407C403.095 461.568 329.486 36.6899 -90.9531 67.1164",
    stroke: "url(#paint4_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M712.111 708.324C389.96 469.872 315.814 59.3685 -90.9375 88.9369",
    stroke: "url(#paint5_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.514 708.241C376.825 478.176 302.143 82.0472 -90.9219 110.757",
    stroke: "url(#paint6_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M664.92 708.159C363.694 486.481 288.475 104.726 -90.9023 132.578",
    stroke: "url(#paint7_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M641.323 708.076C350.56 494.785 274.804 127.405 -90.8867 154.399",
    stroke: "url(#paint8_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M617.726 707.994C337.425 503.09 261.132 150.084 -90.8711 176.22",
    stroke: "url(#paint9_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M594.128 707.911C324.29 511.395 247.461 172.763 -90.8555 198.041",
    stroke: "url(#paint10_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M570.531 707.829C311.155 519.7 233.789 195.442 -90.8398 219.862",
    stroke: "url(#paint11_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M546.934 707.747C298.02 528.005 220.118 218.121 -90.8242 241.683",
    stroke: "url(#paint12_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M523.337 707.666C284.885 536.311 206.446 240.801 -90.8086 263.505",
    stroke: "url(#paint13_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M499.739 707.584C271.75 544.616 192.775 263.481 -90.793 285.326",
    stroke: "url(#paint14_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M476.146 707.503C258.619 552.922 179.107 286.161 -90.7734 307.148",
    stroke: "url(#paint15_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M452.549 707.422C245.484 561.229 165.436 308.842 -90.7578 328.971",
    stroke: "url(#paint16_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428.951 707.342C232.349 569.536 151.764 331.523 -90.7422 350.794",
    stroke: "url(#paint17_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M405.354 707.262C219.214 577.843 138.093 354.204 -90.7266 372.617",
    stroke: "url(#paint18_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M381.761 707.183C206.083 586.151 124.425 376.886 -90.707 394.441",
    stroke: "url(#paint19_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.163 707.105C192.948 594.459 110.754 399.569 -90.6914 416.266",
    stroke: "url(#paint20_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M334.566 707.027C179.814 602.769 97.0819 422.253 -90.6758 438.092",
    stroke: "url(#paint21_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310.969 706.951C166.679 611.079 83.4109 444.937 -90.6602 459.918",
    stroke: "url(#paint22_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M287.372 706.875C153.544 619.391 69.739 467.624 -90.6445 481.747",
    stroke: "url(#paint23_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M263.774 706.802C140.409 627.705 56.068 490.312 -90.6289 503.577",
    stroke: "url(#paint24_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.177 706.732C127.274 636.022 42.396 513.002 -90.6133 525.409",
    stroke: "url(#paint25_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M216.58 706.664C114.139 644.342 28.725 535.696 -90.5977 547.245",
    stroke: "url(#paint26_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M192.986 706.602C101.008 652.667 15.057 558.396 -90.5781 569.086",
    stroke: "url(#paint27_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.389 706.547C87.873 660.999 1.38587 581.102 -90.5625 590.935",
    stroke: "url(#paint28_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.792 706.505C74.7379 669.344 -12.2856 603.821 -90.5469 612.795",
    stroke: "url(#paint29_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.195 706.485C61.6029 677.711 -25.957 626.562 -90.5312 634.678",
    stroke: "url(#paint30_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.597 706.51C48.468 686.123 -39.6285 649.348 -90.5156 656.606",
    stroke: "url(#paint31_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1113.5 708.656C1477.5 436.656 1549.5 -31.3446 2011 1.6561",
    stroke: "url(#paint32_radial_404_15736)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1845 706.655C1884.67 694.655 1973.3 672.255 2010.5 678.655",
    stroke: "url(#paint33_radial_404_15736)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1137.1 708.573C1490.63 444.96 1563.17 -8.66622 2010.98 23.4764",
    stroke: "url(#paint34_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1160.69 708.49C1503.77 453.264 1576.84 14.0118 2010.97 45.2964",
    stroke: "url(#paint35_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1184.29 708.407C1516.9 461.568 1590.51 36.6899 2010.95 67.1164",
    stroke: "url(#paint36_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1207.89 708.324C1530.04 469.872 1604.18 59.3685 2010.94 88.9369",
    stroke: "url(#paint37_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1231.48 708.241C1543.17 478.176 1617.86 82.0472 2010.92 110.757",
    stroke: "url(#paint38_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1255.08 708.159C1556.31 486.481 1631.52 104.726 2010.9 132.578",
    stroke: "url(#paint39_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1278.68 708.076C1569.44 494.785 1645.2 127.405 2010.89 154.399",
    stroke: "url(#paint40_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1302.27 707.994C1582.58 503.09 1658.87 150.084 2010.87 176.22",
    stroke: "url(#paint41_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1325.87 707.911C1595.71 511.395 1672.54 172.763 2010.86 198.041",
    stroke: "url(#paint42_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1349.47 707.829C1608.84 519.7 1686.21 195.442 2010.84 219.862",
    stroke: "url(#paint43_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1373.06 707.747C1621.98 528.005 1699.88 218.121 2010.82 241.683",
    stroke: "url(#paint44_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1396.66 707.666C1635.11 536.311 1713.55 240.801 2010.81 263.505",
    stroke: "url(#paint45_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1420.26 707.584C1648.25 544.616 1727.22 263.481 2010.79 285.326",
    stroke: "url(#paint46_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1443.85 707.503C1661.38 552.922 1740.89 286.161 2010.77 307.148",
    stroke: "url(#paint47_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1467.45 707.422C1674.52 561.229 1754.56 308.842 2010.76 328.971",
    stroke: "url(#paint48_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1491.05 707.342C1687.65 569.536 1768.24 331.523 2010.74 350.794",
    stroke: "url(#paint49_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1514.65 707.262C1700.79 577.843 1781.91 354.204 2010.73 372.617",
    stroke: "url(#paint50_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1538.24 707.183C1713.92 586.151 1795.58 376.886 2010.71 394.441",
    stroke: "url(#paint51_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1561.84 707.105C1727.05 594.459 1809.25 399.569 2010.69 416.266",
    stroke: "url(#paint52_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1585.44 707.027C1740.19 602.769 1822.92 422.253 2010.68 438.092",
    stroke: "url(#paint53_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1609.03 706.951C1753.32 611.079 1836.59 444.937 2010.66 459.918",
    stroke: "url(#paint54_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1632.63 706.875C1766.46 619.391 1850.26 467.624 2010.64 481.747",
    stroke: "url(#paint55_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1656.23 706.802C1779.59 627.705 1863.93 490.312 2010.63 503.577",
    stroke: "url(#paint56_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1679.82 706.732C1792.73 636.022 1877.6 513.002 2010.61 525.409",
    stroke: "url(#paint57_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1703.42 706.664C1805.86 644.342 1891.28 535.696 2010.6 547.245",
    stroke: "url(#paint58_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1727.02 706.602C1818.99 652.667 1904.94 558.396 2010.58 569.086",
    stroke: "url(#paint59_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1750.61 706.547C1832.13 660.999 1918.62 581.102 2010.56 590.935",
    stroke: "url(#paint60_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1774.21 706.505C1845.26 669.344 1932.29 603.821 2010.55 612.795",
    stroke: "url(#paint61_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1797.81 706.485C1858.4 677.711 1945.96 626.562 2010.53 634.678",
    stroke: "url(#paint62_radial_404_15736)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1821.4 706.51C1871.53 686.123 1959.63 649.348 2010.52 656.606",
    stroke: "url(#paint63_radial_404_15736)",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.75 354.328) rotate(90) scale(354.328 448.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.75 692.092) rotate(90) scale(14.5638 82.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(345.959 365.214) rotate(90) scale(343.358 436.944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.168 376.101) rotate(90) scale(332.389 425.137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.377 386.987) rotate(90) scale(321.42 413.331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.587 397.873) rotate(90) scale(310.45 401.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.796 408.76) rotate(90) scale(299.481 389.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.009 419.647) rotate(90) scale(288.512 377.911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.218 430.533) rotate(90) scale(277.543 366.105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.427 441.42) rotate(90) scale(266.574 354.298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.636 452.306) rotate(90) scale(255.605 342.492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.846 463.193) rotate(90) scale(244.636 330.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.055 474.08) rotate(90) scale(233.667 318.879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.264 484.967) rotate(90) scale(222.698 307.073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.473 495.854) rotate(90) scale(211.73 295.266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.686 506.742) rotate(90) scale(200.761 283.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.895 517.629) rotate(90) scale(189.793 271.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.105 528.517) rotate(90) scale(178.825 259.847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.314 539.405) rotate(90) scale(167.857 248.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.527 550.293) rotate(90) scale(156.89 236.234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.736 561.182) rotate(90) scale(145.923 224.427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.945 572.071) rotate(90) scale(134.956 212.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.154 582.96) rotate(90) scale(123.99 200.815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.364 593.851) rotate(90) scale(113.025 189.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.573 604.742) rotate(90) scale(102.06 177.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.782 615.635) rotate(90) scale(91.097 165.395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.991 626.529) rotate(90) scale(80.1355 153.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.204 637.426) rotate(90) scale(69.1765 141.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.413 648.326) rotate(90) scale(58.2213 129.976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6229 659.233) rotate(90) scale(47.2722 118.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8319 670.151) rotate(90) scale(36.3342 106.363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.0408 681.091) rotate(90) scale(25.4188 94.5564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1562.25 354.328) rotate(90) scale(354.328 448.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1927.75 692.092) rotate(90) scale(14.5638 82.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1574.04 365.214) rotate(90) scale(343.358 436.944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1585.83 376.101) rotate(90) scale(332.389 425.137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1597.62 386.987) rotate(90) scale(321.42 413.331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1609.41 397.873) rotate(90) scale(310.45 401.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1621.2 408.76) rotate(90) scale(299.481 389.718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1632.99 419.647) rotate(90) scale(288.512 377.911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1644.78 430.533) rotate(90) scale(277.543 366.105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1656.57 441.42) rotate(90) scale(266.574 354.298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1668.36 452.306) rotate(90) scale(255.605 342.492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1680.15 463.193) rotate(90) scale(244.636 330.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1691.94 474.08) rotate(90) scale(233.667 318.879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1703.73 484.967) rotate(90) scale(222.698 307.073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1715.52 495.854) rotate(90) scale(211.73 295.266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1727.31 506.742) rotate(90) scale(200.761 283.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1739.1 517.629) rotate(90) scale(189.793 271.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1750.9 528.517) rotate(90) scale(178.825 259.847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1762.69 539.405) rotate(90) scale(167.857 248.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1774.48 550.293) rotate(90) scale(156.89 236.234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1786.27 561.182) rotate(90) scale(145.923 224.427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1798.06 572.071) rotate(90) scale(134.956 212.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1809.85 582.96) rotate(90) scale(123.99 200.815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1821.64 593.851) rotate(90) scale(113.025 189.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1833.43 604.742) rotate(90) scale(102.06 177.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1845.22 615.635) rotate(90) scale(91.097 165.395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1857.01 626.529) rotate(90) scale(80.1355 153.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1868.8 637.426) rotate(90) scale(69.1765 141.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1880.59 648.326) rotate(90) scale(58.2213 129.976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1892.38 659.233) rotate(90) scale(47.2722 118.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1904.17 670.151) rotate(90) scale(36.3342 106.363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_404_15736",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1915.96 681.091) rotate(90) scale(25.4188 94.5564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3698BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDFF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.5e7a19fe73f6451d3b44714dff640c4e.svg";
export { ForwardRef as ReactComponent };